module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }